/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useEffect } from 'react';


export default function SizeSelector({ size, onChange, producto, color }) {
  const [isOpen, setIsOpen] = useState(false);
  const [sizes, setSizes] = useState([])
   
  
  const ordenarTallas = (tallas) => {
    const extraerNumeros = (talla) => {
      // Extrae todos los números de la cadena (incluyendo decimales)
      const numeros = talla.match(/\d+(?:\.\d+)?/g) || ['0'];
      return numeros.map(num => parseFloat(num));
    };

    return [...tallas].sort((a, b) => {
      const numerosA = extraerNumeros(a);
      const numerosB = extraerNumeros(b);
      
      // Comparar cada número hasta encontrar una diferencia
      for (let i = 0; i < Math.min(numerosA.length, numerosB.length); i++) {
        if (numerosA[i] !== numerosB[i]) {
          return numerosA[i] - numerosB[i];
        }
      }
      
      // Si todos los números son iguales, mantener el orden original
      return numerosA.length - numerosB.length;
    });
  };

  useEffect(() => {
    const tallasFilters = producto?.inventories
      .filter(objeto => objeto.color_hex === color.dataC)
      .map(objeto => objeto.size);

    if (tallasFilters && tallasFilters.length > 0) {
      // Eliminar duplicados usando Set y convertir de nuevo a array
      const tallasUnicas = [...new Set(tallasFilters)];
      // Ordenar las tallas únicas
      const tallasOrdenadas = ordenarTallas(tallasUnicas);
      setSizes(tallasOrdenadas);
      // Solo actualizar la talla seleccionada si no hay una selección previa o si la selección actual no está en las nuevas tallas
      if (!size || !tallasOrdenadas.includes(size)) {
        onChange(tallasOrdenadas[0], "size");
      }
    }
  }, [color, producto, size])
  
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '300px',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
  };

  const labelStyle = {
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',
  };

  const selectStyle = {
    color: '#000',
    padding: '10px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
  };


  const optionStyle = {
    padding: '8px',
    fontSize: '14px',
    backgroundColor: '#fff',
    color: '#333',
    cursor: 'pointer',
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <label htmlFor="size-select" style={labelStyle}>
        Tamaño del marco:
      </label>
      <div style={containerStyle}>

        <div style={{ position: 'relative' }}>
          <select
            id="size-select"
            value={size}
            onChange={(e) => onChange(e, "size")}
            onFocus={() => setIsOpen(true)}
            onBlur={() => setIsOpen(false)}
            style={selectStyle}
          >
            {sizes.map((sizeOption) => (
              <option key={sizeOption} value={sizeOption} style={optionStyle}>
                {sizeOption}
              </option>
            ))}
          </select>

        </div>
      </div>
    </div>
  );
}

